module.exports = __webpack_public_path__ + "static/media/Small multiple violations of the 14.66c193d1.png";